import { render, staticRenderFns } from "./authenticationV2.vue?vue&type=template&id=52880f2e"
import script from "./authenticationV2.vue?vue&type=script&lang=js"
export * from "./authenticationV2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports